// src/pathology/LicenseDetailsFrame.js
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { updateAccountVariable } from "../actions/authenActions";

const LicenseDetailsFrame = () => {
  const dispatch = useDispatch();
  const [emails, setEmails] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

  const license_key = useSelector(
    (state) => state.authen.loggedInUser?.license_key,
  );

  const report_email = useSelector(
    (state) => state.authen.loggedInUser?.variables?.report_emails,
  );

  useEffect(() => {
    if (report_email) {
      setEmails(report_email);
    }
  }, [report_email]);

  // email validation
  const validateEmails = (emailStr) => {
    const emailList = emailStr
      .split(":")
      .map((e) => e.trim())
      .filter(Boolean);

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    for (const email of emailList) {
      if (!regex.test(email)) {
        return false;
      }
    }
    return true;
  };

  const handleSave = async () => {
    setSaved(false);

    const emailList = emails
      .split(":")
      .map((e) => e.trim())
      .filter(Boolean);

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    for (const email of emailList) {
      if (!regex.test(email)) {
        setError("Enter valid email addresses separated by ':'");
        return;
      }
    }

    const uniqueEmails = [...new Set(emailList)];

    const normalizedEmails = uniqueEmails.join(":");

    setEmails(normalizedEmails);

    setError("");
    setLoading(true);

    try {
      await axios.post(`${baseURL}/licensing/api/variable/add/`, {
        license_key,
        variable_name: "report_emails",
        variable_value: normalizedEmails,
      });

      dispatch(
        updateAccountVariable({
          variables: {
            report_emails: normalizedEmails,
          },
        }),
      );

      setSaved(true);
    } catch (err) {
      console.error(err);
      setError("Failed to save emails.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={1} sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Email Accounts
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Configure additional colon-separated email accounts to receive the daily
        report. Example - report1@email.com:report2@email.com
      </Typography>

      <TextField
        label="Email Addresses"
        multiline
        minRows={3}
        fullWidth
        value={emails}
        onChange={(e) => {
          setEmails(e.target.value);
          setError("");
          setSaved(false);
        }}
        placeholder="email1@example.com:email2@example.com"
        sx={{ mb: 2 }}
      />

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {saved && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {emails.trim()
            ? `${emails.split(":").filter(Boolean).length > 1 ? "Emails" : "Email"} saved successfully.`
            : "Email removed successfully."}
        </Alert>
      )}

      <Box display="flex" justifyContent="flex-end">
        <Button variant="contained" onClick={handleSave} disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </Button>
      </Box>
    </Paper>
  );
};

export default LicenseDetailsFrame;
